import { GridBaseDataProvider } from '../../../../grid/GridBaseDataProvider';
import { Column, ColumnKeys, Domain, DomainController } from '../types';
import {
  GetRowsRequest,
  GetSummaryRequest,
  GetSummaryResponse,
  SetFiltersRequest,
  UpdateSettingsRequest,
  UpdateSettingsResponse,
} from '../../../../grid/types/common';
import { sanitizeObject } from '../../../../utils/sanitization.utils';
import { DEFAULT_PAGE_SIZE } from '../../../../grid/gridView/types';

export default class ADOnPremSensorDataProvider extends GridBaseDataProvider<Column, ColumnKeys> {
  private pageSize: number = DEFAULT_PAGE_SIZE;
  private cachedDomainData: Domain[];
  private adOnpremDomainId: string;

  constructor(public dependencies: any, cachedDomainData: any = null, adOnpremDomainId: any = null) {
    super();
    this.cachedDomainData = cachedDomainData;
    this.adOnpremDomainId = adOnpremDomainId;
  }

  async getSummary(request: GetSummaryRequest<ColumnKeys>): Promise<GetSummaryResponse> {
    return sanitizeObject({ summary: '', numItems: 0 });
  }

  async getDomainData(): Promise<Domain[]> {
    if (!this.cachedDomainData) {
      this.cachedDomainData = await this.dependencies.api.clients.SensorsIntegrations.getDomainsByCompanyId();
    }
    return this.cachedDomainData;
  }

  async getRows(request: GetRowsRequest<Column, ColumnKeys>): Promise<any> {
    request.pageSize = this.pageSize;

    let response = await this.getDomainData();
    let responseDomainControllers = [] as DomainController[];
    if (this.adOnpremDomainId && response[0].domainControllers !== undefined) {
      response = response.filter(x => x._id === this.adOnpremDomainId);
      responseDomainControllers = response[0].domainControllers as DomainController[];
    }
    return { rawEvents: sanitizeObject(responseDomainControllers) };
  }

  async getDomainById(adOnpremDomainId: string) {
    let response = await this.getDomainData();

    response = response.filter(x => x._id === adOnpremDomainId);
    return response[0];
  }

  async updateSettings(params: UpdateSettingsRequest<Column>): Promise<UpdateSettingsResponse> {
    this.pageSize = params.pageSize ?? DEFAULT_PAGE_SIZE;

    return {};
  }

  async setFilters(request: SetFiltersRequest<ColumnKeys>): Promise<{} | undefined> {
    return;
  }
}
